// Formats a US phone number as the user types: (555) 123-4567
export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  if (digits.length <= 3) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

// Formats a stored phone number for display (handles already-formatted or raw digits)
export function formatPhone(value: string | null | undefined): string {
  if (!value) return ''
  return formatPhoneInput(value)
}
